import { gql } from '@apollo/client';

export const getCleaningReportsList = gql`
  query cleaningReports(
    $filter: FilterCleaningReports
    $pagingOptions: PagingOptionsInput!
  ) {
    cleaningReports(filter: $filter, pagingOptions: $pagingOptions) {
      data {
        id
        taskCompletion
        routeName
        pathCoverage
        cleanedSquareMeter
        startDate
        endDate
        isoYear
        isoMonth
        isoWeek
        machineFacility
        machineObject
        machineAlias
        machine {
          id
          materialNumber
          serialNumber
        }
      }
      metadata {
        totalCount
      }
    }
  }
`;

export const getCleaningReportsRouteImage = gql`
  query cleaningReportsRouteImage($cleaningReportIds: [ID!]!) {
    cleaningReportsRouteImage(
      filter: { cleaningReportIds: $cleaningReportIds }
    ) {
      data {
        url
      }
    }
  }
`;
